import Icon from './icon'
import { IconProps } from './icon.types'

export const Line24pxBackIcon = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M15 5L8.35355 11.6464C8.15829 11.8417 8.15829 12.1583 8.35355 12.3536L15 19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
)

export const Line24pxForwardIcon = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M9 6L14.6464 11.6464C14.8417 11.8417 14.8417 12.1583 14.6464 12.3536L9 18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
)

export const Line24pxDownIcon = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M6 9L11.6464 14.6464C11.8417 14.8417 12.1583 14.8417 12.3536 14.6464L18 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
)

export const Line24pxUpIcon = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M18 15L12.3536 9.35355C12.1583 9.15829 11.8417 9.15829 11.6464 9.35355L6 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
)
